import React from "react";
import Loadable from "../../../react-loadable";

const WeaNewTable = Loadable({
  loader: () => import("./WeaNewTable"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaNewTable;



// WEBPACK FOOTER //
// ./ecology9/base/wea-new-table/index.js